import api from './API'

const URL = '/apps'

export default {
  startApp: function (payload, appToken) {
    return api.newRequest('post', `${URL}/${appToken}`, payload)
  }
}
